import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, Dialog, IconButton } from "@mui/material";
import { FC } from "react";

type Props = {
  base64: string,
  open: boolean,
  onClose: () => void
}

export const ImageOverlay: FC<Props> = ({ base64, open, onClose }) => {
  return (
    <Dialog
      open={open}
      onClose={(e, reason) => {
        if (reason === "backdropClick" || reason === "escapeKeyDown") {
          onClose();
        }
      }}
      maxWidth="lg"
    >
      <>
        <IconButton
          onClick={() => onClose()}
          style={{ position: "absolute", right: "0", top: "0", height: "3rem", width: "3rem" }}
          size="large"
        >
          <FontAwesomeIcon size="1x" icon="times" color="black" />
        </IconButton>
        <Box style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
          <img
            src={base64}
            alt=""
            style={{ objectFit: "contain", maxHeight: "100vh", maxWidth: "90%" }}
          />
        </Box>
      </>
    </Dialog>
  );
};